<template>
  <VBusHelper
    :reactOn="$constants.EVENTS.BOOKMAKER.REQUEST_ACCOUNT_CONFIRMATION"
    :handler="() => $refs.modal.show()"
  />
  <VBusHelper
    :reactOn="$constants.EVENTS.BOOKMAKER.BOOKMAKER_ID_CONFIRMED"
    :handler="() => $refs.modal.hide('confirmed_action')"
  />
  <VBusHelper
    :reactOn="$constants.EVENTS.BOOKMAKER.REQUEST_BOOKMAKER_ID_CHANGE"
    :handler="() => $refs.modal.hide()"
  />
  <DialogComponent
    ref="modal"
    type="bottomsheet"
    @closed="
      ({ source }) =>
        source !== 'confirmed_action' &&
        $bus.emit(
          $constants.EVENTS.BOOKMAKER.BOOKMAKER_ID_CONFIRMATION_CANCELED
        )
    "
  >
    <div class="p-6">
      <!-- loading state -->
      <div
        v-if="
          $stores.bookmaker?.state?.bookmakerData?.[
            `${$stores.bookmaker?.state?.bookmakerIdConfirmation?.bookmaker}_${$stores.bookmaker?.state?.bookmakerIdConfirmation?.bookmakerId}`
          ]?.loading
        "
        class="text-center py-8"
      >
        <div class="inline-flex items-center justify-center w-16 h-16 bg-primary/10 rounded-full mb-4">
          <svg class="animate-spin w-8 h-8 text-primary" width="32" height="32" viewBox="0 0 24 24" fill="none">
            <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="3" class="opacity-25"/>
            <path fill="currentColor" class="opacity-75" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"/>
          </svg>
        </div>
        <h3 class="text-lg font-semibold text-gray-900 mb-2">
          Vérification du compte {{ $stores.bookmaker?.state?.bookmakerIdConfirmation?.bookmakerName }}
        </h3>
        <p class="text-gray-500 text-sm">Veuillez patienter...</p>
      </div>

      <!-- error state -->
      <div
        v-else-if="
          $stores.bookmaker?.state?.bookmakerData?.[
            `${$stores.bookmaker?.state?.bookmakerIdConfirmation?.bookmaker}_${$stores.bookmaker?.state?.bookmakerIdConfirmation?.bookmakerId}`
          ]?.error
        "
        class="text-center py-8"
      >
        <div class="inline-flex items-center justify-center w-16 h-16 bg-red-100 rounded-full mb-4">
          <svg class="w-8 h-8 text-red-600" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <circle cx="12" cy="12" r="10"/>
            <path d="M15 9l-6 6M9 9l6 6"/>
          </svg>
        </div>
        <h3 class="text-lg font-semibold text-gray-900 mb-2">
          Erreur de vérification
        </h3>
        <p class="text-red-500 text-sm mb-6">
          {{
            $stores.bookmaker?.state?.bookmakerData?.[
              `${$stores.bookmaker?.state?.bookmakerIdConfirmation?.bookmaker}_${$stores.bookmaker?.state?.bookmakerIdConfirmation?.bookmakerId}`
            ]?.error
          }}
        </p>
        <button
          class="w-full py-4 border border-gray-200 text-gray-700 rounded-xl font-semibold hover:bg-gray-50 transition-all"
          @click="
            $bus.emit($constants.EVENTS.BOOKMAKER.REQUEST_BOOKMAKER_ID_CHANGE, {
              bookmakerId:
                $stores.bookmaker?.state?.bookmakerIdConfirmation?.bookmakerId,
              bookmaker:
                $stores.bookmaker?.state?.bookmakerIdConfirmation?.bookmaker
            })
          "
        >
          Réessayer
        </button>
      </div>

      <!-- success state -->
      <div
        v-else-if="
          $stores.bookmaker?.state?.bookmakerData?.[
            `${$stores.bookmaker?.state?.bookmakerIdConfirmation?.bookmaker}_${$stores.bookmaker?.state?.bookmakerIdConfirmation?.bookmakerId}`
          ]?.data
        "
        class="text-center py-8"
      >
        <div class="inline-flex items-center justify-center w-16 h-16 bg-green-100 rounded-full mb-4">
          <svg class="w-8 h-8 text-green-600" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <polyline points="20 6 9 17 4 12"/>
          </svg>
        </div>
        <h3 class="text-lg font-semibold text-gray-900 mb-2">
          Confirmez votre compte
        </h3>
        <p class="text-gray-600 text-sm mb-6">
          Nous allons utiliser le compte
          <span class="font-semibold text-primary">{{
            $stores.bookmaker?.state?.bookmakerData?.[
              `${$stores.bookmaker?.state?.bookmakerIdConfirmation?.bookmaker}_${$stores.bookmaker?.state?.bookmakerIdConfirmation?.bookmakerId}`
            ]?.data?.name
          }}</span>
          (ID: {{ $stores.bookmaker?.state?.bookmakerIdConfirmation?.bookmakerId }})
        </p>
        <p class="text-gray-500 text-sm mb-6">
          Voulez-vous continuer ?
        </p>

        <div class="flex gap-3">
          <button
            class="flex-1 py-4 border border-gray-200 text-gray-700 rounded-xl font-semibold hover:bg-gray-50 transition-all"
            @click="
              $bus.emit($constants.EVENTS.BOOKMAKER.REQUEST_BOOKMAKER_ID_CHANGE, {
                bookmakerId:
                  $stores.bookmaker?.state?.bookmakerIdConfirmation?.bookmakerId,
                bookmaker:
                  $stores.bookmaker?.state?.bookmakerIdConfirmation?.bookmaker
              })
            "
          >
            Changer
          </button>
          <button
            class="flex-1 py-4 bg-primary text-white rounded-xl font-semibold shadow-lg hover:shadow-xl hover:-translate-y-0.5 transition-all"
            @click="
              $bus.emit($constants.EVENTS.BOOKMAKER.BOOKMAKER_ID_CONFIRMED, {
                bookmakerId:
                  $stores.bookmaker?.state?.bookmakerIdConfirmation?.bookmakerId,
                bookmaker:
                  $stores.bookmaker?.state?.bookmakerIdConfirmation?.bookmaker
              })
            "
          >
            Confirmer
          </button>
        </div>
      </div>
    </div>
  </DialogComponent>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'BookmakerAccountConfirm'
});
</script>
